import { Injectable, Injector, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// https://github.com/scttcper/ngx-toastr/issues/179#issuecomment-325724269

@Injectable()
export class ToastNotificationsService {
  private readonly injector = inject(Injector);

  private get toastr(): ToastrService {
    return this.injector.get(ToastrService);
  }

  openNotification(message: string, type?: string, title?: string): void {
    switch (type) {
      case 'success':
        this.toastr.success(message, title);
        break;
      case 'error':
        this.toastr.error(message, title);
        break;
      case 'warning':
        this.toastr.warning(message, title);
        break;
      case 'info':
        this.toastr.info(message, title);
        break;

      default:
        this.toastr.info(message, title);
        break;
    }
  }

  success(message: string, title?: string): void {
    this.toastr.success(message, title);
  }
  error(message: string, title?: string): void {
    this.toastr.error(message, title);
  }
  warn(message: string, title?: string): void {
    this.toastr.warning(message, title);
  }
  info(message: string, title?: string): void {
    this.toastr.info(message, title);
  }
}
